
import { instantiate } from './communicationCardWeb.uninstantiated.mjs';
export default (await instantiate()).exports;
